import { zeroUUID } from '@sbt-web/optimizely-sdk';
import { getSSROptimizelyClient } from '@tools/optimizely/ssrClient';
import { getCategoryForStickyBanner } from '@client/components/Scaffolding/utils/getCategoryForStickyBanner';
import type { Category } from '@sbt-web/category-utils';
import type { ItemCategory } from '@sbt-web/network/types';
import type { StickyBannerContent } from '@sbt-web/header';

/*
 * Utility function to check if the returned Optimizely configuration is valid
 */
const isNonEmptyConfig = (config: unknown) =>
  !!config && typeof config === 'object' && Object.keys(config).length > 0;

/*
 * Utility function to generate an Optimizely configuration path based on placement and category
 */
const getFeatureVariablePath = (
  placement: string,
  categorySlug?: string
): string => {
  if (categorySlug && categorySlug !== '') {
    return `subito-product-marketing.${placement}.${categorySlug}.sticky-banner`;
  }

  return `subito-product-marketing.${placement}.sticky-banner`;
};

export const getStickyBannerContent = async (
  section: 'adview' | 'listing',
  category?: Category | ItemCategory
): Promise<StickyBannerContent | undefined> => {
  const ssrOptimizely = await getSSROptimizelyClient();

  if (!ssrOptimizely) {
    return;
  }

  const categorySlug = getCategoryForStickyBanner(category);
  const featureVariablePath = getFeatureVariablePath(section, categorySlug);

  const isFeatureEnabled = ssrOptimizely.isFeatureEnabled(
    featureVariablePath,
    zeroUUID
  );

  if (!isFeatureEnabled) {
    return;
  }

  const config = ssrOptimizely.getAllFeatureVariables(
    featureVariablePath,
    zeroUUID
  ) as StickyBannerContent;

  if (!isNonEmptyConfig(config)) {
    return;
  }

  return config;
};
